import { getWithAuth } from '../../../Basic/HttpService';

export const getAllVehicleSchedules = async (filterID, custId, depotId, year, serviceAgentID) => {
    if (filterID === ':') filterID = '';
    let res = await getWithAuth(
        `Schedules?mode=${filterID}&CustomerID=${custId || ''}&DepotID=${depotId || ''}&Year=${year || ''}&ServiceAgentID=${serviceAgentID || ''}`
    );
    return res;
};
